<script>
import Drawer from "@/components/drawer";

// Custom Components
import BookingDetails from "@/components/booking-details.vue";
import PageHeader from "@/components/page-header";
import Pagination from "@/components/Pagination.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Notification section Component

export default {
  page: {
    title: "Notifications",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Drawer,
    BookingDetails,
    Pagination,
  },
  data() {
    return {
      title: "Notification and Alerts",
      isLoading: true,
      table: {
        tableData: [],
        previous: null,
        next: null,
        totalPages: 0,
        currentPage: 0,
        size: 100,
      },
      isShowBookingDetail: false,
      selectedBooking: null,
    };
  },
  computed: {
    ...authComputed,
    bookingDetailsProps() {
      return {
        booking: this.selectedBooking,
      };
    },
  },
  mounted() {
    this.getNotificationListData(`?size=${this.table.size}`);
  },
  methods: {
    // Method is used for get bed data
    async getNotificationListData(filter = "") {
      try {
        this.table.tableData = [];
        this.isLoading = true;
        const response = await UserService.getNotificationList(filter);
        this.table.tableData = response.results;
        this.table.previous = response.previous;
        this.table.totalPages = response.total_pages;
        this.table.next = response.next;
        this.table.currentPage = response.page_number;
        this.isLoading = false;
        this.$root.$emit("notificatinRead");
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used for open details drawer
    openDetailDrawer(data) {
      if (data.model_type == "booking") {
        this.selectedBooking = { id: data.model_id };
        this.openBookingDetails();
      }
    },
    // Method is used for open booking details
    openBookingDetails() {
      this.isShowBookingDetail = !this.isShowBookingDetail;
    },
    // Method is used to get more guest
    onPageChange(page) {
      this.getNotificationListData(`?page=${page}&size=100`);
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <div class="table-responsive">
                  <v-table
                    :data="table.tableData"
                    class="table table-hover mb-0"
                    ref="my-table"
                  >
                    <thead class="table-light" slot="head">
                      <tr>
                        <th class="w-25">Title</th>
                        <th class="w-25">Content Text</th>
                        <th class="w-25">Model Type</th>
                        <th class="w-25">Created</th>
                      </tr>
                    </thead>
                    <tbody
                      class="infinite-list"
                      slot="body"
                      slot-scope="{ displayData }"
                      v-if="!isLoading && table.tableData.length !== 0"
                    >
                      <tr
                        v-for="(noti, index) in displayData"
                        :key="index"
                        @click="openDetailDrawer(noti)"
                      >
                        <td>
                          {{ noti.title }}
                        </td>
                        <td>
                          {{ noti.content_text }}
                        </td>
                        <td class="text-capitalize">
                          <span
                            class="badge align-items-center py-1 px-2 card-badge"
                            :class="`badge-soft-${noti.level}`"
                          >
                            {{ String(noti.model_type).replaceAll("_", " ") }}
                          </span>
                        </td>
                        <td>
                          {{ global_format_date_and_time(noti.created_at) }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody slot="body" v-else-if="isLoading">
                      <tr v-for="item in 20" :key="item">
                        <td class="placeholder-glow" v-for="no in 4" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody slot="body" v-else>
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                  <Pagination
                    v-if="table.previous !== null || table.next !== null"
                    :totalPages="table.totalPages"
                    :currentPage="table.currentPage"
                    @pagechanged="onPageChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Method is use for open drawer -->
    <Drawer
      @close="openBookingDetails"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1240"
      class="w-100"
    >
      <div v-if="isShowBookingDetail">
        <BookingDetails :currentProps="bookingDetailsProps" />
      </div>
    </Drawer>
  </div>
</template>
